import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import { useReactiveVar } from 'utils/reactivity';

export const useNavigationArrow = () => {
  const { data, reactActivePageId, setActivePageId } = useLandingV2Context();
  const activePageId = useReactiveVar(reactActivePageId);
  const links = data.landing.pages.map((p) => ({ id: p.id }));
  const isLastLink = links[links.length - 1].id === activePageId;

  // Do not delete this functional , this will be implemented after MVP

  /* const onScrollHandler = () => {
    if (isLastLink) {
      setActivePageId(links[0].id);
    } else
      links.find((el, i) => {
        if (el.id === activePageId) {
          setActivePageId(links[i + 1].id);
        }
      });
  };*/

  const onScrollHandler = () => {
    setActivePageId({ pageId: links[1].id, notifyExternalEnv: true, withScroll: true });
  };

  return { onScrollHandler, isLastLink };
};
